(ns common.modal.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Dialog$default" :as Dialog]
            ["@mui/material/DialogActions$default" :as DialogActions]
            ["@mui/material/DialogContent$default" :as DialogContent]
            ["@mui/material/DialogTitle$default" :as DialogTitle]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["react" :as react]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            [common.modal.db]
            [common.util :as util]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]])
  (:require-macros [common.modal.view]))

(defn modal-root
  []
  (let [{:keys [content max-width sx]} @(rf/subscribe [:modal/current])
        props @(rf/subscribe [:modal/props])]
    [:> Dialog
     {:open @(rf/subscribe [:modal/open])
      :onClose #(rf/dispatch [:modal/close])
      ;; To test the contents are working during the transition.
      ;; :transitionDuration 2000
      :TransitionProps {:onExited #(rf/dispatch [:modal/closed])}
      :maxWidth max-width
      :fullWidth (when max-width
                   true)
      :sx sx}
     ;; content will be nil after transition is done
     (when content
       [:f> content props])]))

(def modifier-sx
  {:info {:border-top 5
          :border-top-color "primary.main"}
   :error {:border-top 5
           :border-top-color "error.main"}
   :success {:border-top 5
             :border-top-color "success.main"}
   :warning {:border-top 5
             :border-top-color "warning.main"}})

(defn modal
  [{:keys [title modifier footer]
    :or {modifier :info}}
   & children]
  [:> Box
   {:sx (get modifier-sx modifier)
    :data-testid "modal-dialog"}
   [:> Stack
    {:direction "row"
     :align-items "center"
     :sx {:px 3}}
    [:> DialogTitle
     {:variant "h2"
      :sx {:px 0}
      :data-testid "modal-title"}
     title]
    [:> Box {:flex-grow 1}]
    [:> Stack
     {:align-items "center"}
     [:> IconButton
      {:on-click #(rf/dispatch [:modal/close])
       :sx {:flex-shrink 0}
       :data-testid "modal-close-button"}
      [:> Icon "close"]]]]
   (into [:> DialogContent
          {:data-testid "modal-body"}]
         children)
   (when footer
     [:> DialogActions {:style {:padding-right 24
                                :padding-bottom 16}} footer])])

(defui modal-v2
  "A new design for the modal, without status line at the top and with a little bit different layout."
  [{:keys [title footer icon dialog-content-props sx children]}]
  ($ Stack
     {:sx (util/spread-obj
           #js {:overflow "hidden"
                :padding 3
                :pt 1
                :borderRadius 8}
           sx)
      :data-testid "modal-dialog"}
     ($ Stack
        {:direction "row"
         :alignItems "center"
         :spacing 1}
        (when icon
          (if (react/isValidElement icon)
            icon
            ($ icon
               {:sx #js {:padding 2}})))
        ($ DialogTitle
           {:variant "h2"
            :sx #js {:px 0}
            :data-testid "modal-title"}
           title)
        ($ Box {:flexGrow 2})
        ($ Stack
           {:alignItems "center"}
           ($ IconButton
              ;; Use the on-mouse-down event to prevent the on-blur event
              ;; from being called before the on-click event.
              ;; This prevents clicking outside of the button as on-blur
              ;; may trigger some validation messages, which shift the UI.
              {:onMouseDown #(rf/dispatch [:modal/close])
               :sx #js {:flexShrink 0
                        :p 0}
               :data-testid "modal-close-button"}
              ($ Icon "close"))))
     ($ DialogContent
        (merge {:data-testid "modal-body"
                :sx (util/merge-objects #js {:padding 0
                                             :overflowX "hidden"}
                                        (:sx dialog-content-props))}
               (dissoc dialog-content-props :sx))
        children)
     (when footer
       ($ DialogActions {:sx #js {:mt 2 :padding 0}} footer))))

(defui confirmation-modal
  [{:keys [title action-fn confirm-message confirm-details]}]
  ($ modal-v2
     {:title title
      :icon ($ SvgIcon {:color "warning"}
               ($ AlertIcon))
      :footer ($ Stack {:direction "row" :gap 1}
                 ($ Button {:variant "text"
                            :sx #js {:color "text.primary"}
                            :onClick #(rf/dispatch [:modal/close])}
                    "Cancel")
                 ($ Button {:variant "contained"
                            :color "warning"
                            :onClick #(do (rf/dispatch [:modal/close])
                                          (action-fn))}
                    (or confirm-message "Confirm")))}
     (when confirm-details
       ($ Stack {:sx #js {:width "450px"}}
          ($ :p confirm-details)))))

